<template>
  <div>
    <div class="app-content content devcontent">
      <div class="content-overlay"></div>
      <div class="header-navbar-shadow"></div>
      <div class="content-wrapper">
        <div class="content-header-left mb-1 pt-0 pad_top_mar_bot-5">
          <div class="container-fluid">
            <div class="row breadcrumbs-top">
              <div class="col-md-12 content-header-left px-0">
                <h3 class="content-header-title float-left mb-0">
                  Accident Management
                </h3>
                <div class="breadcrumb-wrapper">
                  <ol class="breadcrumb">
                    <li class="breadcrumb-item">
                        <router-link to="/accident-reports"> List</router-link>
                    </li>
                    <li class="breadcrumb-item">
                        <router-link to="/accident-management">Report Accident</router-link >
                    </li>
                  </ol>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-body">
          <section>
            <div class="card">
              <div class="card-header px-0 common_top_title_searchbgst_dock">
                <div class="container-fluid">
                  <div class="row row fc_my-05">
                    <div class="w-auto px-1 mobile-padding-0-2">
                      <div
                        class="avatar bg-light-secondary rounded d-inline-flex mr-1"
                      >
                        <div class="avatar-content">
                          <i
                            class="i_icon_st la-people-carry las lab font-medium-5"
                          ></i>
                        </div>
                      </div>
                      <h4 class="card-title d-inline-flex ml-0 mb-0">
                        Accident  Form
                      </h4>
                    </div>
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-4 mb-0 mobileview_b_8 mobileview_b_px00"
                    >
                      <treeselect
                        placeholder="Select Camera"
                        v-model="camera"
                        :options="camera_options"
                        @input="handleCameraSelection"
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-12 px-0">
                <div class="card text-center mb-1">
                  <div
                    class="card-card-header text-editar_discription_jobs masters_detailstabing_pills px-0"
                  >
                    <div
                      class="nav-tabs epg-tabs subcategory-tabs no-bg scroll-both"
                    >
                      <nav class="nav-tabs-wrapper main_divtabsview">
                        <ul
                          class="tabs_masters_detailstabing_pills nav nav-pills nav-pill-primary pb-0 nav-tabs-items dragscroll"
                        >
                          <li
                            class="nav-item tabs-item active main_divtabsviewtoggle"
                            data-day="1"
                          ></li>
                        </ul>
                      </nav>
                    </div>
                     <vue-element-loading
                      :active="isLoading"
                      spinner="bar-fade-scale"
                     />
                    <div class="tab-content">
                      <div
                        role="tabpanel"
                        class="tab-pane active"
                        id="accident_form"
                      >
                        <div class="container px-0" v-if="accident_form">
                          <div class="row mx-0 mt-1">
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Select Vehicle</label
                              >
                              <treeselect
                                placeholder="Select Vehicle"
                                :options="vehicleList"
                                v-model="formData.vehicle_id"
                                @input="handleVehicleChange"
                              />
                            </div>

                            <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Driver Photo</label
                              >
                              <cropper
                                class="cropper"
                                id="driver_photo-canvas"
                                ref="driver_photo-cropper"
                                :src="captures.driver_photo.img"
                                :canvas="{
                                  width: 350,
                                  height: 350,
                                }"
                                v-if="captures.driver_photo.showCropper"
                                :default-size="defaultSize"
                              />
                              <div
                                v-else
                                class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto"
                              >
                                <img
                                  alt=""
                                  class="round img-fluid"
                                  src="../../public/images/icons/camera4.png"
                                />
                              </div>
                              <video
                                id="driver_photo-video"
                                class="overlay-camera"
                                autoplay
                                @click="captureDocumentPhoto('driver_photo')"
                              ></video>

                              <div
                                class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0"
                              >
                                <button
                                  class="gateentyscan_camera_icon mr-1"
                                  @click="turnOnCamera('driver_photo')"
                                >
                                  <em class="las la-camera feather-camera"></em>
                                </button>
                                <button
                                  class="btn btn-secondary cropimagebutton01"
                                  @click="cropImage('driver_photo')"
                                >
                                  Crop
                                </button>
                                <audio
                                  id="driver_photo-sound"
                                  :src="photoCaptureSound"
                                ></audio>
                              </div>
                            </div> -->
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Driver Name</label
                              >
                              <input
                                class="form-control"
                                type="text"
                                placeholder="Enter Driver Name  "
                                v-model="formData.driver_name"
                              />
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Mobile</label
                              >
                              <input
                                class="form-control"
                                type="text"
                                placeholder="Enter Mobile No  "
                                v-model="formData.driver_mobile"
                              />
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Landmark</label
                              >
                              <textarea
                                class="form-control"
                                id="#"
                                rows="1"
                                placeholder="Enter Safety Information"
                                v-model="formData.landmark"
                              ></textarea>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Comment/Reason</label
                              >
                              <treeselect
                                placeholder="Select Vehicle"
                                v-model="formData.comment"
                                :options="commentList"
                              />
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Accident Type</label
                              >
                              <treeselect
                                placeholder="Select Accident type"
                                v-model="formData.accidenttype"
                                :options="level"
                              />
                            </div>
                            <!-- <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >Upload Photos<span class=""
                                  ></span
                                ></label
                              >
                              <cropper
                                class="cropper"
                                id="accident_photo-canvas"
                                ref="accident_photo-cropper"
                                :src="captures.accident_photo.img"
                                :canvas="{
                                  width: 350,
                                  height: 350,
                                }"
                                v-if="captures.accident_photo.showCropper"
                                :default-size="accidentDefaultSize"
                              />
                              <div
                                v-else
                                class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto"
                              >
                                <img
                                  alt=""
                                  class="round img-fluid"
                                  src="../../../public/images/icons/camera4.png"
                                />
                              </div>
                              <video
                                id="accident_photo-video"
                                class="overlay-camera"
                                autoplay
                                @click="captureDocumentPhoto('accident_photo')"
                              ></video>

                              <div
                                class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0"
                              >
                                <button
                                  class="gateentyscan_camera_icon mr-1"
                                  @click="turnOnCamera('accident_photo')"
                                >
                                  <em class="las la-camera feather-camera"></em>
                                </button>
                                <button
                                  class="btn btn-secondary cropimagebutton01"
                                  @click="cropImage('accident_photo')"
                                >
                                  Crop
                                </button>
                                <audio
                                  id="accident_photo-sound"
                                  :src="photoCaptureSound"
                                ></audio>
                              </div>
                            </div> -->
                            <!-- <div
                              class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1 plate_photoscan_mobile_mb-5"
                            >
                              <label class="form-label text-left w-100"
                                >Upload Video<span class=""
                                  ></span
                                ></label
                              >
                              <div class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto">
                                <video id="myVideo" playsinline class="video-js vjs-default-skin"></video>
                                <button type="button" class="btn btn-info" @click.prevent="startRecording()" v-bind:disabled="isStartRecording" id="btnStart">Start Recording</button>
                                <button
                                class="btn btn-secondary"
                                  @click="stopRecording"
                                >
                                  Stop Recording
                                </button>
                              </div>
                            </div> -->
                            <div class="col-12 col-sm-6 col-md-6 col-lg-4 mb-1">
                              <label class="form-label text-left w-100"
                                >FIR Copy<span class=""
                                  ></span
                                ></label
                              >
                              <cropper
                                class="cropper"
                                id="FIR_copy_photo-canvas"
                                ref="FIR_copy_photo-cropper"
                                :src="captures.FIR_copy_photo.img"
                                :canvas="{
                                  width: 350,
                                  height: 350,
                                }"
                                v-if="captures.FIR_copy_photo.showCropper"
                                :default-size="FIRCopyDefaultSize"
                              />
                              <div
                                v-else
                                class="col-sm-12 plate_photoscan_mobile_canvasimage platesecondphoto"
                              >
                                <img
                                  alt=""
                                  class="round img-fluid"
                                  src="../../../public/images/icons/camera4.png"
                                />
                              </div>
                              <video
                                id="FIR_copy_photo-video"
                                class="overlay-camera"
                                autoplay
                                @click="captureDocumentPhoto('FIR_copy_photo')"
                              ></video>

                              <div
                                class="col-sm-12 plate_photoscan_mobilebtn_mx-5 mt-1 text-right px-0"
                              >
                                <button
                                  class="gateentyscan_camera_icon mr-1"
                                  @click="turnOnCamera('FIR_copy_photo')"
                                >
                                  <em class="las la-camera feather-camera"></em>
                                </button>
                                <button
                                  class="btn btn-secondary cropimagebutton01"
                                  @click="cropImage('FIR_copy_photo')"
                                >
                                  Crop
                                </button>
                                <audio
                                  id="FIR_copy_photo-sound"
                                  :src="photoCaptureSound"
                                ></audio>
                              </div>
                            </div>

                            <div
                              class="pull-right text-right col-12 col-sm-6 col-md-6 col-lg-12 mb-1 common_trs_buttons_res"
                            >
                              <button
                                type="button"
                                class="btn btn-relief-primary common-btn_btn_view"
                                style="margin-top: 18px !important"
                                @click="saveData"
                                :disabled="!validateForm()"
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Pagination from "vue-pagination-2";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Treeselect from "@riophae/vue-treeselect";
import VueElementLoading from "vue-element-loading";
import {
  XCircleIcon,
  FileIcon,
  UploadIcon,
  DownloadIcon,
  EditIcon,
} from "vue-feather-icons";
import CONSTANT from "../../constants.js";
import common_methods from "../../utils/common_methods";
import searchMasterNameList from "../../utils/searchMasterNameList";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

import 'video.js/dist/video-js.min.css';
import videojs from 'video.js';
import RecordRTC from 'recordrtc';
import 'videojs-record/dist/css/videojs.record.css';
import Record from 'videojs-record/dist/videojs.record.js';
import FFmpegjsEngine from 'videojs-record/dist/plugins/videojs.record.ffmpegjs.js';

export default {
  name: "accidentManagement",
  mixins: [common_methods, searchMasterNameList],
  components: {
    Treeselect,
    DatePicker,
    VueElementLoading,
    Pagination,
    UploadIcon,
    FileIcon,
    XCircleIcon,
    DownloadIcon,
    EditIcon,
    Pagination,
  },
  data() {
    return {
      un: "",
      isLoading: false,
      isShipmentsSyncing: false,
      isMasterListLoading: true,
      pagefeatures: [],
      isFormEdit: false,
      commentList: [
        { id: "Brake Failure", label: "Brake Failure" },
        { id: "Extreme Weather ", label: "Extreme Weather " },
        { id: "Distracted Driving", label: "Distracted Driving" },
        { id: "Mechanical Failure", label: "Mechanical Failure" },
        { id: "Reckless Driving" , label: "Reckless Driving" },
        { id: "Distracted Driving", label: "Distracted Driving" },
        { id: "Speeding" , label: "Speeding" },
        { id: "Poor Road Conditions", label: "Poor Road Conditions" },
      ],
      level: [
        { id: "minor", label: "Minor" },
        { id: "major", label:"Major"} ,
        { id: "fatal", label: "Fatal" },
      ],
      camera_options: [],
      camera: null,
      torch: false,
      accident_form: false,
      cropAllowed: [ "accident_photo", "FIR_copy_photo"],
      fileTitle: [ "accident_photo", "FIR_copy_photo"],
      isRecording: true,
      mediaRecorder: null,
      recordedChunks: [],
      recordedVideoURL: null,
      vehicleList: [],
      player: '',
      retake: 0,
      isSaveDisabled: false,
      isStartRecording: false,
      isRetakeDisabled: true,
      submitText: 'Submit',
      options: {
        // video.js options
        controls: true,
        bigPlayButton: false,
        controlBar: {
          deviceButton: false,
          recordToggle: false,
          pipToggle: false
        },
        loop: false,
        fluid: false,
        width: 320,
        height: 240,
        plugins: {
            // videojs-record plugin options
          record: {
              pip: false,
              image: false,
              audio: false,
              video: true,
              maxLength: 5,
              displayMilliseconds: true,
              debug: true
          }
        }
      },
      accident_form: {
        url: "/accident",
        list: [],
        totalcount: 0,
        pageCount: 0,
        page: 1,
        pagelimit: CONSTANT.LIMIT,
        currPageNum: 0,
        pageoffset: 1,
        presignedUrls: [],
      },
      formData: {
        vehicle_id: null,
        driver_name: null,
        driver_mobile: null,
        landmark: null,
        comment: null,
        accidenttype:null
      },
      captures: {
        driver_photo: {
          stream: null,
          file: null,
          img: null,
          isCropped: false,
          showCropper: false,
        },
        accident_photo: {
          stream: null,
          file: null,
          img: null,
          isCropped: false,
          showCropper: false,
        },
        FIR_copy_photo: {
          stream: null,
          file: null,
          img: null,
          isCropped: false,
          showCropper: false,
        },
        accident: {
          file: null
        }
      },
      photoCaptureSound: "sound/iphone-camera-capture-6448.wav",
    };
  },
  created() {
    this.getCameraSelection();
    this.getVehicleList();
    this.getMasterList();
  },
  mounted() {
    this.player = videojs('myVideo', this.options, () => {
        // print version information at startup
        // var msg = 'Using video.js ' + videojs.VERSION +
        //     ' with videojs-record ' + videojs.getPluginVersion('record') +
        //     ' and recordrtc ' + RecordRTC.version;
        // videojs.log(msg);
    });
    // error handling
    this.player.on('deviceReady', () => {
        this.player.record().start();
        console.log('device ready:');
    });
    this.player.on('deviceError', () => {
        console.log('device error:', this.player.deviceErrorCode);
    });
    this.player.on('error', (element, error) => {
        console.error(error);
    });
    // user clicked the record button and started recording
    this.player.on('startRecord', () => {
        console.log('started recording!');
    });
    // user completed recording and stream is available
    this.player.on('finishRecord', () => {
        this.isSaveDisabled = false;
        if(this.retake == 0) {
            this.isRetakeDisabled = false;
        }
        // the blob object contains the recorded data that
        // can be downloaded by the user, stored on server etc.
        console.log('finished recording: ', this.player.recordedData);
    });
  },
  methods: {
    handleVehicleChange(value){
      if(value){
        console.log(typeof value)
        this.isLoading = true;
        this.getDriverDetails(value);
      }
      this.resetform();
    },
    getDriverDetails(vehicle_id){
      let url = `/accident/driver-details/${vehicle_id}`
      this.makeRequest("GET",url)
      .then((result) => {
        this.isLoading = false;
         let data = result.data.data.row; 
         if(data && data.length>0){
            this.formData.driver_name = data[0].driver_name;
            this.formData.driver_mobile = data[0].driver_mobile;
            this.formData.vehicle_id = vehicle_id;
            console.log(data)
            if(data) {
           var str = `<div>
              <p><strong></strong>Click Submit to save Accident Report</p>
              <section>
              <span><strong>Driver Name : </strong>${this.formData.driver_name}</span> <br/>
              <span><strong>Driver Mobile : </strong>${this.formData.driver_mobile}</span>  <br/>
              <span><strong>Vehicle No : </strong>${this.vehicleList.find((item)=>item.id===vehicle_id).label}</span><br/>
              </section>
            </div>`
          } 
          Swal.fire({
                    title: 'Auto Submit?',
                    text: "Click here to Submit..",
                    html:str,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Submit'
                    }).then((result) => {
                    if (result.isConfirmed) {
                  console.log("auto submitted form")
                  this.saveData();
         }})

         }else{
          this.sweetAlertSnackbar(result.data.message,"error")
         }
         
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    startRecording() {
            this.isRecording = true;
            this.player.record().getDevice();
        },
    stopRecording() {
       this.player.record().stopDevice();
       var data = this.player.recordedData;
       this.storeFile(
          new File([data], `accident_report_video_record.webm`, { type: "video/webm;codecs=vp8" }),
          "accident"
        );
    },

    submitVideo() {
      // this.isSaveDisabled = true;
      this.isRetakeDisabled = true;
      var data = this.player.recordedData;
      var formData = new FormData();
      formData.append('video', data, data.name);
      this.submitText = "Uploading "+data.name;
      console.log('uploading recording:', data.name);
      this.player.record().stopDevice();
      console.log(data, "__++++")
      // fetch(this.uploadUrl, {
      //     method: 'POST',
      //     body: formData,
      //     headers: {
      //         'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      //     }
      // }).then(
      //     success => {
      //         console.log('recording upload complete.');
      //         this.submitText = "Upload Complete";
      //     }
      // ).catch(
      //     error =>{
      //         console.error('an upload error occurred!');
      //         this.submitText = "Upload Failed";
      //     }
      // );
  },

    findImageUrl(tab, key) {
      let presignedUrls = this[tab].presignedUrls;
      let urlObj = presignedUrls.find((obj) => obj.fileKey === key);
      if (urlObj) return urlObj.url;
      return "";
    },
    getPhotoLink(key) {
      this.getPresignUrl(key)
        .then((result) => {
          this.photo_links = [result];
          // $('.imagepreview').attr('src', this.photo_link);
          // $("#imagemodal").modal("show");
        })
        .catch((e) => {
          this.displayError(e);
          this.photo_links = [];
        });
    },
    getMasterList(tab = "accident_form") {
      this.isMasterListLoading = true;
      let url = this[tab].url;
      let method = "POST";
      let payload = {
        page: this[tab].page,
        rows: this[tab].pagelimit,
      };
      this.makeRequest(method, url, payload)
        .then((result) => {
          this.isMasterListLoading = false;
          this[tab].list = result.data.data.rows;
          this[tab].totalcount = result.data.data.count;
          this[tab].pageCount = Math.ceil(
            result.data.data.count / this[tab].pagelimit
          );
          this[tab].presignedUrls = result.data.data.presignedUrls;
        })
        .catch((e) => {
          this.isMasterListLoading = false;
          this.displayError(e);
        });
    },
    handlePageChange(pageNum, tab) {
      this[tab].pageoffset = pageNum;
      this[tab].currPageNum = pageNum - 1;

      this.getMasterList(tab);
      setTimeout(() => {
        $("html, body").animate({
          scrollTop: $(`#${tab}`).offset().top - 70,
        });
      }, 500);
    },
    validateForm() {
      let isValid = true;
      if (!this.formData.vehicle_id) {
        isValid = false;
      }
      if (!this.formData.driver_name) {
        isValid = false;
      }
      if (!this.formData.driver_mobile) {
        isValid = false;
      }
      // if (!this.formData.landmark) {
      //   isValid = false;
      // }
      // if (!this.formData.comment) {
      //   isValid = false;
      // }
      // if (!this.formData.accidenttype) {
      //   isValid = false;
      // }

      // for (let title of this.fileTitle) {
      //   let file = this.captures[title].file;
      //   if (!file) {
      //     isValid = false;
      //   }
      // }

      return isValid;
    },
    async saveData() {
      // if (!this.validateForm()) {
      //   this.sweetAlertSnackbar(
      //     "Form was invalidated. Make sure that all reuired fields are filled out!",
      //     "error"
      //   );
      //   return;
      // }
      this.isLoading = true;

      var formData = new FormData();
      for (let fileTitle of this.fileTitle) {
        if (this.captures[fileTitle].file) {
          formData.append("files", this.captures[fileTitle].file);
        }
      }
      if(this.player.recordedData) {
        formData.append("files", this.captures.accident.file)
      }
      if (!this.is_seal_optional) {
        for (let i = 0; i < this.sealNumberCount; i++) {
          let fileValue = this.captures.seal[`file${i}`];
          fileValue[`seal_number_${i}`] =
            this.captures.seal[`seal_number_${i}`];
          formData.append("files", fileValue);
        }
      }

      formData.append("folder", "accident");
      let url = "/files/s3/bulkUploadFiles";
      axios({
        "content-type": "multipart/form-data",
        method: "POST",
        url: url,
        data: formData,
      })
        .then((result) => {
          if (result.data.status) {
            let files = result.data.data;
            let payload = this.formData;
            for (let file of files) {
              let fileName = file.fileName.split(".")[0];
              payload[fileName] = file.fileKey;
            }
            let method = "POST";
            let url = "/IVR/accident-report";
            axios({
              method,
              url,
              data: payload,
            })
              .then((result) => {
                this.isLoading = false;
                this.resetform();
                if (result && result.data && result.data.status) {
                  this.sweetAlertSnackbar(result.data.message, "success");
                } else {
                  this.sweetAlertSnackbar(result.data.message, "error");
                }
              })
              .catch((e) => {
                this.displayError(e);
              });
            // this.sweetAlertSnackbar(result.data.message, 'success', 'top')
          } else {
            this.sweetAlertSnackbar(result.data.message, "error");
          }
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    async turnOnCamera(id2, index = "") {
      this.isLoading = true;

      let id = id2 + index;
      let video = document.getElementById(`${id}-video`);
      video.style.display = "block";
      let isCroppingAllowed = this.cropAllowed.includes(id2);

      let videoConstraints = {
        audio: false,
        video: {
          width: { ideal: isCroppingAllowed ? 2160 : 4096 },
          height: { ideal: isCroppingAllowed ? 4096 : 2160 },
          facingMode: {
            exact: "environment",
          },
        },
      };
      if (this.camera) {
        videoConstraints = { video: { facingMode: "user" }, audio: false };
      }
      try {
        let stream = await navigator.mediaDevices.getUserMedia(
          videoConstraints
        );
        let tracks = stream.getVideoTracks();
        if (this.torch) {
          if (tracks.length) {
            const videoTrack = tracks[0];
            await videoTrack.applyConstraints({ torch: true });
          }
        } else {
          if (tracks.length) {
            const videoTrack = tracks[0];
            await videoTrack.applyConstraints({ torch: false });
          }
        }
        this.captures[id2].stream = stream;
        video.srcObject = stream;
      } catch (e) {
        video.style.display = "none";
        this.displayError(e);
      }
      this.isLoading = false;
    },
    // async startRecording() {
    //   this.isRecording = true;
    //   let videoConstraints = {
    //     audio: true,
    //     video: {
    //       width: { ideal: isCroppingAllowed ? 2160 : 4096 },
    //       height: { ideal: isCroppingAllowed ? 4096 : 2160 },
    //       facingMode: {
    //         exact: "environment",
    //       },
    //     },
    //   };
    //   if (this.camera) {
    //     videoConstraints = { video: { facingMode: "user" }, audio: true };
    //   }
    //   try {
    //     const stream = await navigator.mediaDevices.getUserMedia(videoConstraints);
    //     let video = document.getElementById("record-video");
    //     video.style.display = "block";
    //     this.$refs.videoElement.src = window.URL.createObjectURL(stream);
    //     this.mediaRecorder = new MediaRecorder(stream);
    //     this.mediaRecorder.ondataavailable = (event) => {
    //       console.log(event)
    //       this.recordedChunks.push(event.data);
    //     };
    //     this.mediaRecorder.start();
    //   } catch(e) {
    //     console.log(e)
    //   }
        
    // },
    // stopRecording() {
    //   this.isRecording = false;
    //   this.mediaRecorder.stop();
    //    this.mediaRecorder.stream.getTracks().forEach(track => track.stop()); // Stop all tracks
    //   const blob = new Blob(this.recordedChunks, { type: "video/webm" });
    //   this.recordedVideoURL = URL.createObjectURL(blob);
    //   console.log(this.recordedVideoURL, "+++")
    //   this.recordedChunks = [];
    // },
    async captureDocumentPhoto(id2, index = "") {
      let id = id2 + index;
      let video = document.querySelector(`#${id}-video`);
      const canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      this.captures[id2].img = canvas.toDataURL("image/jpeg");
      this.captures[id2].showCropper = true;
      this.captures[id2].isCropped = false;

      let stream = video.srcObject;
      let tracks = stream.getVideoTracks();
      if (this.torch && tracks.length) {
        const videoTrack = tracks[0];
        await videoTrack.applyConstraints({ torch: false });
      }
      video.srcObject = null;

      canvas.toBlob((blob) => {
        this.storeFile(
          new File([blob], `${id}_photo.jpg`, { type: "image/jpeg" }),
          id2,
          index
        );
      }, "image/jpeg");
      if (this.captures[id2].stream) {
        this.captures[id2].stream.getTracks().forEach(function (track) {
          track.stop();
        });
      }
      video.style.display = "none";
    },
    cropImage(id2, index = "") {
      let id = id2 + index;
      let cropperRef = this.$refs[`${id2}-cropper`];
      if (!cropperRef) return;
      const { canvas } = cropperRef.getResult();
      this.captures[id2].img = canvas.toDataURL("image/jpeg");
      this.captures[id2].isCropped = true;

      canvas.toBlob((blob) => {
        this.storeFile(
          new File([blob], `${id}_photo.jpg`, { type: "image/jpeg" }),
          id,
          index
        );
      }, "image/jpeg");
    },
    storeFile(file, id, index = "") {
      if (index !== "") {
        this.captures[id][`file${index}`] = file;
      } else {
        this.captures[id].file = file;
      }
    },
    async getCameraSelection() {
      const devices = await navigator.mediaDevices.enumerateDevices();
      const videoDevices = devices.filter(
        (device) => device.kind === "videoinput"
      );
      const options = videoDevices.map((videoDevice) => {
        return {
          id: videoDevice.deviceId,
          label: videoDevice.label,
        };
      });
      this.camera_options = options;
    },
    handleCameraSelection(id) {
      this.camera = id;
    },
    resetform() {
      this.formData.vehicle_id = null;
      this.formData.driver_name = null;
      this.formData.driver_mobile = null;
      this.formData.landmark = null;
      this.formData.comment = null;
      this.formData.accidenttype = null;
      this.captures.driver_photo = {
        stream: null,
        file: null,
        img: null,
        isCropped: false,
        showCropper: false,
      };
      this.captures.accident_photo = {
        stream: null,
        file: null,
        img: null,
        isCropped: false,
        showCropper: false,
      };
      this.captures.FIR_copy_photo = {
        stream: null,
        file: null,
        img: null,
        isCropped: false,
        showCropper: false,
      };
    },
    toggleMasterCreate() {
      if (this.isFormEdit) {
        this.resetform("accident_form");
      }
      this.isFormEdit = false;
      this.accident_form = !this.accident_form;
    },
    getVehicleList() {
      this.searchNameMasterList(
        "vehicle_registration_master",
        "vehicle_number_plate",
        null,
        "vehicle_id",
        "vehicle_transaction_type"
      )
        .then((result) => {
          this.vehicleList = result.data;
        })
        .catch((e) => {
          this.displayError(e);
        });
    },
    defaultSize({ imageSize, visibleArea }) {
      let width = (visibleArea || imageSize).width;
      let height = (visibleArea || imageSize).height;
      let isCropped = this.captures.driver_photo.isCropped;
      if (!isCropped) {
        return {
          width: width,
          height: height,
        };
      }
      return {
        width,
        height,
      };
    },
    accidentDefaultSize({ imageSize, visibleArea }) {
      let width = (visibleArea || imageSize).width;
      let height = (visibleArea || imageSize).height;
      let isCropped = this.captures.accident_photo.isCropped;
      if (!isCropped) {
        return {
          width: width,
          height: height,
        };
      }
      return {
        width,
        height,
      };
    },
    FIRCopyDefaultSize({ imageSize, visibleArea }) {
      let width = (visibleArea || imageSize).width;
      let height = (visibleArea || imageSize).height;
      let isCropped = this.captures.FIR_copy_photo.isCropped;
      if (!isCropped) {
        return {
          width: width,
          height: height,
        };
      }
      return {
        width,
        height,
      };
    },
  },
  beforeDestroy() {
        if (this.player) {
            this.player.dispose();
        }
    }
};
</script>
<style scoped>
.alignment {
  margin-left: 20px;
  margin-bottom: 20px;
}
.requiredField {
  margin-left: 2px;
  color: red;
}
#overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}

.overlay-camera {
  position: fixed;
  display: none;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 1);
  z-index: 2;
  cursor: pointer;
}
.video-sm {
  max-width: 100%;
  height: 100%
}
</style>
